import 'reset-css'
import '@/assets/css/global.css'
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import api from '@/api/index'
import 'lib-flexible'
import Meta from "vue-meta"
import 'animate.css'
import Mixin from "@/mixin";
import { Carousel, CarouselItem } from 'element-ui'

Vue.config.productionTip = false
Vue.prototype.$api = api;

Vue.use(Meta)
Vue.use(Carousel)
Vue.use(CarouselItem)
Vue.mixin(Mixin)

new Vue({
	router,
	render: h => h(App)
}).$mount('#app')
